import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import OrganizationCodePage from './pages/auth/organization'
import LoginPage from './pages/auth/login'
import MainPage from './pages/main/index'

function App(): React.JSX.Element {


  return (
    <Router>
      <Routes>
        {/* 重定向根路径到组织代码页面 */}
        <Route path="/" element={<Navigate to="/auth/organization" replace />} />

        {/* 认证相关路由 */}
        <Route path="/auth/organization" element={<OrganizationCodePage />} />
        <Route path="/auth/login" element={<LoginPage />} />

        {/* 主页面 */}
        <Route path="/main" element={<MainPage />} />

        {/* 兜底路由 */}
        <Route path="*" element={<Navigate to="/auth/organization" replace />} />
      </Routes>
    </Router>
  )
}

export default App
